import { OrcaFull } from "../../components/src/video/orca/OrcaFull";
import { firstLineExecution } from "./firstLineExecution";

firstLineExecution();

export default OrcaFull;
